import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save, get }    from "apps/actions/common";
import { api } from "apps/api";
import serializeJSON    from 'utilities/serialize_json';
class Form extends BaseAjaxForm {
  validFunction = null;
  submitFunction = save;
  // init(){
  //   super.init();
  //   this.watch();
  // }
}
riot.mixin('forms.orders.checking_jobno', Form as riot.TagMixin)
